import { Metrics } from '../resources/metrics/metrics-model';
import { timezone } from '../config/env';

export function addDays(date: Date, days: number): Date {
  date.setDate(date.getDate() + days);

  return date;
}

export function subtractDays(date: Date, days: number): Date {
  addDays(date, -days);

  return date;
}

export function addMinutes(date: Date, minutes: number): Date {
  date.setMinutes(date.getMinutes() + minutes);

  return date;
}

export function subtractMinutes(date: Date, minutes: number): Date {
  addMinutes(date, -minutes);

  return date;
}

export function daysDiff(dateA: Date, dateB: Date): number {
  const dayInMillis = 1000 * 60 * 60 * 24;

  return Math.abs(dateB.getTime() - dateA.getTime()) / dayInMillis;
}

export function toISODateString(date: string): string {
  return date.split('T')[0];
}

export function toISOString(date: Date): string {
  return toISODateString(date.toISOString());
}

export function toLocaleString(isoDateString: string): string {
  const date = new Date(isoDateString);
  return date.toLocaleString();
}

export function formatMetricsExecutionTime(metricsData?: Metrics[] | null): string | undefined {
  const totalExecutions = metricsData?.reduce((acc, curr) => acc + curr.numberOfExecutions, 0);
  const totalExecutionTime = metricsData?.reduce((acc, curr) => acc + curr.totalExecutionTime, 0);

  const executionTimeInMillis = totalExecutions && totalExecutionTime ? totalExecutionTime / totalExecutions : -1;
  return formatExecutionTime(executionTimeInMillis);
}

export function formatExecutionTime(executionTime?: number): string | undefined {
  const executionTimeInMillis = executionTime ?? -1;
  let formattedExecutionTime: string | undefined;

  if (executionTimeInMillis >= 0) {
    if (executionTimeInMillis >= 1000) {
      const seconds = executionTimeInMillis / 1000;
      formattedExecutionTime = Number(seconds).toFixed(1) + 's';
    } else {
      formattedExecutionTime = Number(executionTimeInMillis).toFixed() + 'ms';
    }
  }

  return formattedExecutionTime;
}

export function arrayToCorrectTimezone(value: number[]): string {
  const [year, month, day, hour, minute, second, nano] = value;
  const millis = Math.floor((nano || 0) / 1_000_000);
  const date = new Date(Date.UTC(year, month - 1, day, hour, minute, second, millis));
  if (timezone === '') {
    return date.toLocaleString();
  }

  const options: Intl.DateTimeFormatOptions = {
    timeZone: timezone,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  };

  return date.toLocaleString('en-US', options);
}
